import React from "react";
import toast from "react-hot-toast";
import { ItemsAddedToCartBanner } from "@/components/scanToOrder/itemsAddedToCartBanner";

export const toastService = {
  notifyItemAdded: () => {
    toast(<ItemsAddedToCartBanner />, {
      duration: 4000,
      style: {
        background: "transparent",
        boxShadow: "none",
        padding: 0,
        marginTop: "100px",
      },
      position: "top-center",
    });
  },
};
